import React, { useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { any, func } from "prop-types";
import * as style from "../../../containers/styles.module.scss";
import Checkbox from "../../../common/Checkbox/index";
import { postReflexAllenInductionProgramme } from "../../../redux/actions";
import history from "../../../history";

const InductionProgramme = ({ reflexAllenOnboarding, postForm }) => {
  const initialItems = [
    {
      name: "personalProtectiveClothingAndEquipment",
      text: "Personal Protective Clothing & Equipment",
    },
    { name: "introductionToSupervisor", text: "Introduction to Supervisor" },
    { name: "introductionToCollegues", text: "Introduction to Colleagues" },
    { name: "locationWorkstation", text: "Location/Workstation " },
    { name: "toilets", text: "Toilets" },
    { name: "canteen", text: "Canteen" },
    { name: "carParking", text: "Car Parking" },
    { name: "clockingInOutMachine", text: "Clocking In/Out Machine" },
    {
      name: "jobTraining",
      text: "Job Training & Standards of Behaviour Required",
    },
    { name: "noSmokingPolicy", text: "No Smoking Policy" },
    { name: "mobilePhonePolicy", text: "Mobile Phone Policy" },
    {
      name: "useOfPersonalStereos",
      text: "Use of Personal Stereos, Ipods & MP3s",
    },
    { name: "accessToEmployeeHandbook", text: "Access to Employee Handbook" },
    { name: "qualityProcedures", text: "Quality Procedures" },
    {
      name: "fireExitsEvacuationProcedureAndAssemblyPoint",
      text: "Fire Exits, Evacuation Procedure & Assembly Point",
    },
    {
      name: "locationOfFireExtinguishers",
      text: "Location of Fire Extinguishers",
    },
    {
      name: "firstAiders",
      text: "First Aiders, Location of First Aid Kit & Accident Reporting",
    },
    {
      name: "healthAndSafetyInductionRules",
      text: "Health & Safety Induction & Rules",
    },
    {
      name: "cleanlinesContaminationControl",
      text: "Cleanliness/Contamination Control",
    },
  ].map((inductionItem) => {
    return {
      ...inductionItem,
      isChecked: reflexAllenOnboarding.inductionForm.checkedItems
        ? reflexAllenOnboarding.inductionForm.checkedItems.includes(
            inductionItem.name
          )
        : false,
    };
  });
  const isNewForm =
    reflexAllenOnboarding &&
    reflexAllenOnboarding.inductionForm.checkedItems &&
    reflexAllenOnboarding.inductionForm.checkedItems.length === 0 &&
    reflexAllenOnboarding.inductionForm.uncheckedItems.length === 0;
  const isFinishedForm =
    reflexAllenOnboarding &&
    reflexAllenOnboarding.inductionForm.uncheckedItems &&
    reflexAllenOnboarding.inductionForm.uncheckedItems.length === 0 &&
    !isNewForm;
  const [itemState, setItemState] = useState(initialItems);

  const handleCheckboxClick = (inductionItem) => {
    setItemState(
      itemState.map((item) => {
        if (item.name === inductionItem.name) {
          return {
            name: inductionItem.name,
            text: inductionItem.text,
            isChecked:
              initialItems.find((elem) => elem.name === item.name).isChecked ===
              true
                ? true
                : !item.isChecked,
          };
        }
        return item;
      })
    );
  };

  return (
    <div className={style.container}>
      <h2>Induction Checklist</h2>
      <div className="bg-white p-1 my-2">
        <p>
          This checklist must be completed by no later than the end of your
          first day.
        </p>
        <div>
          {itemState.map((inductionItem, i) => (
            <div key={i}>
              <Checkbox
                label={inductionItem.text}
                isChecked={inductionItem.isChecked}
                onClick={() => handleCheckboxClick(inductionItem)}
              />
            </div>
          ))}
        </div>
        <div className={style.container__buttons}>
          <Link to="/profile/edit/onboarding" className="btn btn-outline-dark">
            Cancel
          </Link>
          {!isFinishedForm && (
            <button
              className="btn btn-primary"
              onClick={() => {
                postForm({
                  checklist_name: "inductionForm",
                  items: Object.fromEntries(
                    itemState.map((item) => [item.name, item.isChecked])
                  ),
                });
                history.push("/profile/edit/onboarding");
              }}
            >
              Save
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

InductionProgramme.propTypes = {
  reflexAllenOnboarding: any,
  postForm: func,
};

const mapStateToProps = (state) => ({
  reflexAllenOnboarding: state.core.app.reflexAllen,
});

const mapDispatchToProps = {
  postForm: postReflexAllenInductionProgramme,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(InductionProgramme);
